<template>
  <div>
    <b-row>
      <b-col
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-datepicker
          v-model="query.startDate"
          class="el-def"
          placeholder="조회기간(Fr)"
          style="width: 240px"
        />
        <label class="ml-50 mr-50">~</label>
        <b-form-datepicker
          v-model="query.endDate"
          class="el-def"
          placeholder="조회기간(To)"
          style="width: 240px"
        />
        <label class="ml-50">(*당일데이터 조회 불가)</label>
      </b-col>
      <b-col
        md="6"
        class="d-flex align-items-center justify-content-end"
      >
        <label class="ml-50">{{ noticeMsg }}</label>
        <b-button
          variant="outline-dark"
          class="btn-search ml-1"
          :disabled="!excelVisible"
          @click.prevent="excelDownload()"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-50"
          />
          <span>엑셀 다운로드</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from '@axios'
import { onMounted, ref, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { saveAs } from "file-saver"

export default {
  components: {
  },
  props: {
    liveinfoId: {
      type: Number,
      default: null,
      required: false,
    },
    selectedData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  setup(props) {
    const excelVisible = ref(false)
    const noticeMsg = ref(null)

    onMounted(() => {
      validateExcelVisible()
    })

    watch(() => props.liveinfoId, () => {
      validateExcelVisible()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const query = ref({
      startDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
      endDate: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
    })

    const validateExcelVisible = () => {
      if (props.liveinfoId === null) {
        excelVisible.value = false
        noticeMsg.value = '라이브 DI를 선택해 주세요.'
        return
      }

      const visibleDate = '2025-08-28'
      if (props.selectedData?.liveDiEndDate && dayjs(props.selectedData?.liveDiEndDate).isBefore(visibleDate)) {
        excelVisible.value = false
        noticeMsg.value = '라이브 DI 업데이트로 2025-08-28 이전 데이터는 제공되지 않습니다.'
        return
      }

      excelVisible.value = true
      noticeMsg.value = null

      if (props.selectedData?.liveDiStartDate && dayjs(props.selectedData?.liveDiStartDate).isBefore(visibleDate)) {
        query.value.startDate = visibleDate
      }
    }

    const excelDownload = async () => {
      axios.post(`/fa/statistics-ext/live-di/excel-yid`, {
        startDate: query.value.startDate,
        endDate: query.value.endDate,
        liveInfoId: props.liveinfoId,
      }, { responseType: 'blob' })
        .then(rs => {
          const blob = new Blob([rs.data])
          saveAs(blob, `라이브DI 통계(요양기관 리스트).xlsx`)
        })
        .catch(err => {
          pushToast('danger', `데이터 조회 중 오류가 발생하였습니다.${err}`)
        })
    }
    return {
      excelVisible,
      query,
      noticeMsg,
      validateExcelVisible,
      excelDownload,
    }
  },
}
</script>
